module.exports = require("eth-rpc-errors");